import { SEA_TURTLE_WEB_API } from "@/constants/appConstant";

export const TransportRequestService = {
  submit(formData) {
    const payload = {
      documentNumber: formData.soChungTu || null,
      shippingDate: formData.daySendQuote || null,

      senderCustomerName: formData.customerName || null,
      senderAddress: formData.senderAddress || null,
      senderPhone: formData.senderPhone || null,
      senderContactPerson: formData.contactPersonSender || null,
      senderRequests: formData.senderRequests || null,

      receiverProjectName: formData.projectCompany || null,
      receiverAddress: formData.receiverAddress || null,
      receiverPhone: formData.receiverPhone || null,
      receiverContactPerson: formData.contactPersonReceiver || null,

      agreedPrice: formData.priceAgreement || null,
      paymentMethod: formData.paymentMethod || null,
      finalAmount: formData.priceAgreement*1.08 || null,


      billingContactName: formData.paymentPerson || null,
      billingContactPhone: formData.paymentPhone || null,
      billingInvoiceEmail: formData.emailInvoice || null,

      invoiceCompanyName: formData.companyInvoice || null,
      invoiceCompanyAddress: formData.addressInvoice || null,
      invoiceTaxCode: formData.taxCode || null,

      cargoItems: [
        {
          itemName: formData.productName || null,
          quantity: formData.quantity || null,
          weight: formData.weight || null,
          volume: formData.volume || null,
          otherDetails: formData.otherDetails || null,
        },
      ],
    };

    console.log("Payload gửi BE:", payload);

    return fetch(`${SEA_TURTLE_WEB_API}/transport-requests`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
      body: JSON.stringify(payload),
    }).then(async (response) => {
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Lỗi khi gửi yêu cầu.");
      }
      return response.json();
    });
  },
};
